export const detailUrl = ({ id }) => {
  return `/configcenter/tenant-portal/detail/${id}`;
};
export const overviewUrl = () => {
  return `/configcenter/tenant-portal`;
};
